import styled from "styled-components";
import FOLDER_SVG from "assets/images/folder.svg";
import useLocation from "features/homework/hooks/useLocation";
import { hw } from "../homeworkUi";

interface LocationProps{
    nowFolder:string,
    selectedReport:string
}

const Location = ({nowFolder, selectedReport}:LocationProps) => {
    const {locationList} = useLocation(nowFolder, selectedReport);

    const viewLocation = () => {
        if(!locationList.length){
            return <Name $muted>전체</Name>;
        }
        return locationList.map((item, index) => {
            const last = index === locationList.length - 1;
            return (
                <ItemWrap key={index}>
                    <Sep>/</Sep>
                    <Name $muted={!last}>{item}</Name>
                </ItemWrap>
            )
        })
    }

    return(
        <Container>
            <Icon src={FOLDER_SVG} alt="" />
            {viewLocation()}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
    width: 100%;
    padding: 8px 10px;
    border-radius: ${hw.radiusSm};
    border: 1px solid ${hw.border};
    background: ${hw.bg};
    overflow: hidden;
`;

const Icon = styled.img`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.7;
`;

const Name = styled.span<{ $muted?: boolean }>`
    color: ${props => props.$muted ? hw.textMuted : hw.text};
    font-size: 13px;
    font-weight: ${props => props.$muted ? 400 : 600};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Sep = styled.span`
    color: ${hw.textSubtle};
    font-size: 12px;
`;

const ItemWrap = styled.span`
    display: flex;
    gap: 6px;
    align-items: center;
    min-width: 0;
`;

export default Location;
